import { render, staticRenderFns } from "./IntegrationAdd.vue?vue&type=template&id=5542f6c5&scoped=true"
import script from "./IntegrationAdd.vue?vue&type=script&lang=js"
export * from "./IntegrationAdd.vue?vue&type=script&lang=js"
import style0 from "./IntegrationAdd.vue?vue&type=style&index=0&id=5542f6c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5542f6c5",
  null
  
)

export default component.exports